import ServiceWrapper from 'Services/ServiceWrapper';
import { ConfigurationData } from '../types';
import AuthManager from 'Common/AuthManager';

const MID_WAY_URL = process.env.REACT_APP_CONNECTION_API;

export const fetchConfiguration = async (channelKey: string): Promise<{ success: boolean; data?: ConfigurationData; error?: string }> => {
    try {
        const response = await ServiceWrapper.doGet(
            `${MID_WAY_URL}gms_configuration/${channelKey}`,
            null,
            null,
            AuthManager.getGmsToken()
        );

        if (response?.errorfound || !response?.data?.done) {
            return {
                success: false,
                error: 'Failed to fetch configuration',
            };
        }

        return {
            success: true,
            data: response.data.data,
        };
    } catch (error) {
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Unknown error',
        };
    }
}

export const updateConfiguration = async (channelKey: string, config: ConfigurationData): Promise<{ success: boolean; error?: string }> => {
    try {
        const response = await ServiceWrapper.doPost(
            `${MID_WAY_URL}gms_configuration/${channelKey}`,
            config,
            null,
            AuthManager.getGmsToken()
        );

        if (response?.errorfound || !response?.data?.done) {
            return {
                success: false,
                error: 'Failed to save configuration',
            };
        }

        return {
            success: true,
        };
    } catch (error) {
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Unknown error',
        };
    }
}